import { createSlice } from '@reduxjs/toolkit';

import { estelamSabtAhvalThunk } from 'Feature/Common/Common/Actions/Thunks/estelamSabtAhvalThunk';
import { getActiveModdatHayeBimehNameh } from 'Feature/Common/Common/Actions/Thunks/getActiveModdatHayeBimehNameh';
import { getAddressWithPostCodeThunk } from 'Feature/Common/Common/Actions/Thunks/getAddressWithPostCodeThunk';
import { SefrKiloometrEnum } from 'Feature/Khodro/Common/Enums/SefrKiloometrEnum';
import { TaghvimSaleSakhtEnum } from 'Feature/Khodro/Common/Enums/TaghvimSaleSakhtEnum';
import { GetAllAnvaeSherkatBimeh } from 'Feature/Khodro/Common/Thunks/GetAllAnvaeSherkatBimeh';
import { getAllAnvaePelak } from 'Feature/Khodro/Common/Thunks/getAllAnvaePelak';
import { getAllAnvaeVasilehNaghleyeh } from 'Feature/Khodro/Common/Thunks/getAllAnvaeVasilehNaghleyeh';
import { getAllBrandHaByNoeVasilehNaghlieh } from 'Feature/Khodro/Common/Thunks/getAllBrandHaByNoeVasilehNaghlieh';
import { getAllHarfHayePelak } from 'Feature/Khodro/Common/Thunks/getAllHarfHayePelak';
import { getAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh } from 'Feature/Khodro/Common/Thunks/getAllMoredEstefadehHayeKhodro';
import { getAllRangHayeKhodro } from 'Feature/Khodro/Common/Thunks/getAllRangHayeKhodro';
import { getAllTipHaByBrand } from 'Feature/Khodro/Common/Thunks/getAllTipHaByBrand';
import { getEstelamDarsadTakhfif } from 'Feature/Khodro/Common/Thunks/getEstelamDarsadTakhfif';
import { getEstelamWithShomarehBimehNamehAndShomarehEntezami } from 'Feature/Khodro/Common/Thunks/getEstelamWithShomarehBimehNamehAndShomarehEntezami';
import { getSerialHayePelakByHarfPelak } from 'Feature/Khodro/Common/Thunks/getSerialHayePelakByHarfPelak';
import { addToOrder } from 'Feature/Khodro/ShakhsSales/Thunks/addToOrder';
import { estelamShakhsSales } from 'Feature/Khodro/ShakhsSales/Thunks/estelamShakhsSales';
import { getActiveTaahodSalesJaani } from 'Feature/Khodro/ShakhsSales/Thunks/getActiveTaahodSalesJaani';
import { getActiveTaahodSalesSarneshin } from 'Feature/Khodro/ShakhsSales/Thunks/getActiveTaahodSalesSarneshin';
import { getAllTaahodatSalesMali } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTaahodatSalesMali';
import { getAllTakhfifHayeJarimehSales } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTakhfifHayeJarimehSales';
import { getAllTakhfifHayeJarimehSarneshin } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTakhfifHayeJarimehSarneshin';
import { getAllTarhHayeSodoorByNoeBimeh } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTarhHayeSodoorByNoeBimeh';
import { getBimehNamehExpireDateMaxDay } from 'Feature/Khodro/ShakhsSales/Thunks/getBimehNamehExpireDateMaxDay';
import { getCodeShenasehPardakhtShakhsSalesChangePelak } from 'Feature/Khodro/ShakhsSales/Thunks/getCodeShenasehPardakhtShakhsSalesChangePelak';
import isDuplicateBimehNamehShakhsSalesInOrder from 'Feature/Khodro/ShakhsSales/Thunks/isDuplicateBimehNamehShakhsSalesInOrder';
import Consts from 'Framework/Consts';
import LabelValueType from 'Shared/Core/Common/Models/LabelValueType';
import { ClearAllToasts } from 'Shared/Toast';
import { gregorianDateTime } from 'Shared/Utils/Extensions/String/StringExtensions';

import ITakhfifHayeJarimehSalesQr from '../../../Queries/ITakhfifHayeJarimehSalesQr';
import ITakhfifHayeJarimehSarneshinQr from '../../../Queries/ITakhfifHayeJarimehSarneshinQr';
import SherkatBimehGhablInitialState from '../../EstelamAndSodoor/reducers/InitialStates/SherkatBimehGhablInitialState';

import SodoorBimehNamehByTavizPelakInitialState from './SodoorBimehNamehByTavizPelakInitialState';

export const sodoorBimehNamehByTavizPelakSlice = createSlice({
  name: 'ShakhSales/SodoorBimehNamehByTavizPelak',
  initialState: SodoorBimehNamehByTavizPelakInitialState,

  reducers: {
    setSodoorBimehNamehByTavizPelakInitialState: (state) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand =
        SodoorBimehNamehByTavizPelakInitialState.getCodeShenasehPardakhtShakhsSalesCommand;

      state.isMablaghKharidBimehNamehMoreThanHaghBimeh =
        SodoorBimehNamehByTavizPelakInitialState.isMablaghKharidBimehNamehMoreThanHaghBimeh;

      state.isSuccess = SodoorBimehNamehByTavizPelakInitialState.isSuccess;
      state.StepOneData = SodoorBimehNamehByTavizPelakInitialState.StepOneData;
      state.StepTwoData = SodoorBimehNamehByTavizPelakInitialState.StepTwoData;
      state.StepThreeData = SodoorBimehNamehByTavizPelakInitialState.StepThreeData;
      state.StepFourData = SodoorBimehNamehByTavizPelakInitialState.StepFourData;
      state.StepFiveData = SodoorBimehNamehByTavizPelakInitialState.StepFiveData;
      state.estelamBimehMarkazi = SodoorBimehNamehByTavizPelakInitialState.estelamBimehMarkazi;
      state.estelamCommand = SodoorBimehNamehByTavizPelakInitialState.estelamCommand;
      state.estelamSabtAhval = SodoorBimehNamehByTavizPelakInitialState.estelamSabtAhval;
      state.noePelak = SodoorBimehNamehByTavizPelakInitialState.noePelak;
      state.isCommandFilled = SodoorBimehNamehByTavizPelakInitialState.isCommandFilled;
      state.tarafHayeGharardad = SodoorBimehNamehByTavizPelakInitialState.tarafHayeGharardad;
      state.anvaeVasilehNaghleyeh = SodoorBimehNamehByTavizPelakInitialState.anvaeVasilehNaghleyeh;
      state.tarhTakhfif = SodoorBimehNamehByTavizPelakInitialState.tarhTakhfif;
      state.taahodatSalesMali = SodoorBimehNamehByTavizPelakInitialState.taahodatSalesMali;
      state.moredEstefadehHayeKhodro = SodoorBimehNamehByTavizPelakInitialState.moredEstefadehHayeKhodro;
      state.brandHa = SodoorBimehNamehByTavizPelakInitialState.brandHa;
      state.tipHa = SodoorBimehNamehByTavizPelakInitialState.tipHa;
      state.anvaePelak = SodoorBimehNamehByTavizPelakInitialState.anvaePelak;
      state.rangHa = SodoorBimehNamehByTavizPelakInitialState.rangHa;
      state.taahodatSalesSarneshin = SodoorBimehNamehByTavizPelakInitialState.taahodatSalesSarneshin;
      state.taahodatSalesJaani = SodoorBimehNamehByTavizPelakInitialState.taahodatSalesJaani;
      state.countries = SodoorBimehNamehByTavizPelakInitialState.countries;

      state.anvaeSherkatBimeh = SodoorBimehNamehByTavizPelakInitialState.anvaeSherkatBimeh;
      state.getCodeShenasehPardakhtShakhsSalesResult =
        SodoorBimehNamehByTavizPelakInitialState.getCodeShenasehPardakhtShakhsSalesResult;
      state.serialPelaks = SodoorBimehNamehByTavizPelakInitialState.serialPelaks;
      state.addToOrderResponse = SodoorBimehNamehByTavizPelakInitialState.addToOrderResponse;
      state.sodoorWizard = SodoorBimehNamehByTavizPelakInitialState.sodoorWizard;
      state.niazBeEstelamBimehMarkazi = SodoorBimehNamehByTavizPelakInitialState.niazBeEstelamBimehMarkazi;
      state.takhfifHayeJarimehSarneshin = SodoorBimehNamehByTavizPelakInitialState.takhfifHayeJarimehSarneshin;
      state.bimehNamehExpireDateMaxDay = SodoorBimehNamehByTavizPelakInitialState.bimehNamehExpireDateMaxDay;
      state.haghBimehPardakhti = SodoorBimehNamehByTavizPelakInitialState.haghBimehPardakhti;
    },

    setEstelamSalesCommand: (state, action) => {
      state.estelamCommand = action.payload;
    },

    setStepOneModel: (state, action) => {
      state.StepOneData = action.payload;
      state.estelamResult.loaded = false;
    },

    setStepOneCommand: (state) => {
      if (state.StepOneData) {
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.shomarehEntezami1 = state.StepOneData
          .shomarehEntezami1 as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.shomarehEntezami2 = state.StepOneData
          ?.shomarehEntezami2?.label as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.shomarehEntezami3 = state.StepOneData
          .shomarehEntezami3 as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.sefrKiloometr = SefrKiloometrEnum.NO;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.serialPelakCoreId = String(
          state?.StepOneData?.serialPelak?.value
        );
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.shomarehShasi = state.estelamBimehMarkazi.data
          ?.vasilehNaghlieh.shomarehshasi as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.shomarehMotor = state.estelamBimehMarkazi.data
          ?.vasilehNaghlieh.shomarehMotor as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.keshvarSazandehCoreId =
          state.estelamBimehMarkazi.data?.vasilehNaghlieh?.countryCentInsurCode === '1'
            ? Consts.env.REACT_APP_MELLIAT_ID
            : (state.estelamBimehMarkazi.data?.vasilehNaghlieh?.countryCentInsurCode as string);
        state.getCodeShenasehPardakhtShakhsSalesCommand.sherkatBimehGhabl.niazBeEstelamBimehMarkazi =
          SherkatBimehGhablInitialState.niazBeEstelamBimehMarkazi;
      }
    },
    setTarafHayeGharardadCommand: (state, action) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand.tarafHayeGharardad = action.payload;
    },
    setTarafHayeGharardadModel: (state, action) => {
      state.tarafHayeGharardad = action.payload;
    },
    setEstelamBimehMarkazi: (state, action) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.codeYektaBimehMarkazi =
        action.payload.codeYektaBimehMarkazi;
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.shomarehBimehNameh =
        action.payload.shomarehBimehNameh;
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.shomarehMotor = action.payload.shomarehMotor;
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.shomarehShasi = action.payload.shomarehShasi;
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.tarikhShorooBimehnameh =
        gregorianDateTime(action.payload.tarikhShorooBimehnameh) ?? undefined;
      state.getCodeShenasehPardakhtShakhsSalesCommand.bimehMarkazi.tarikhEnghezaBimehnameh =
        gregorianDateTime(action.payload.tarikhEnghezaBimehnameh) ?? undefined;
    },

    setStepTwoModel: (state, action) => {
      state.StepTwoData = action.payload;
      state.estelamResult.loaded = false;
    },
    setStepTwoCommand: (state) => {
      if (state.StepTwoData) {
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.moredEstefadehCoreId = state.StepTwoData
          .moredEstefadeh?.value as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.noePelakCoreId = state.StepTwoData.noePelak
          ?.value as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.noeVasilehNaghleyeh = state.StepTwoData
          .noeVasilehNaghleyeh?.value as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.rangCoreId = state.StepTwoData
          .rangCoreId as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.saleSakht = state.StepTwoData.saleSakht;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.vin = state.StepTwoData.vin;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.taghvimSaleSakht = state.StepTwoData
          .taghvimSaleSakht?.value as TaghvimSaleSakhtEnum;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.tipCoreId = state.StepTwoData.tip
          ?.value as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.vasilehNaghlieh.rangCoreId = state.StepTwoData
          .rangCoreId as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.sherkatBimehGhabl.noeSherkatBimehCoreId = state
          .estelamBimehMarkazi.data?.sherkatBimehCoreId as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.sherkatBimehGhabl.shomarehBimehNameh = state.estelamBimehMarkazi
          .data?.shomarehBimehNameh as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.sherkatBimehGhabl.tarikhEnghezaBimehnameh = gregorianDateTime(
          state.estelamBimehMarkazi.data?.tarikhEngheza
        );
        state.getCodeShenasehPardakhtShakhsSalesCommand.bimehNameh.tedaadSaalHavadesBG = state.StepTwoData
          .tedaadSaalHavadesBG as number;
        state.getCodeShenasehPardakhtShakhsSalesCommand.bimehNameh.tedaadSaalSalesBG = state.StepTwoData
          .tedaadSaalSalesBG as number;
        state.getCodeShenasehPardakhtShakhsSalesCommand.bimehNameh.darsadTakhfifSalesBG = state.StepTwoData
          .darsadTakhfifSalesBG as number;
        state.getCodeShenasehPardakhtShakhsSalesCommand.bimehNameh.darsadTakhfifHavadesBG = state.StepTwoData
          .darsadTakhfifHavadesBG as number;
        state.getCodeShenasehPardakhtShakhsSalesCommand.bimehNameh.vaziatKhesaratSalesBGCoreId = state.StepTwoData
          .vaziatKhesaratSalesBGCoreId as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.bimehNameh.vaziatKhesaratHavadesBGCoreId = state.StepTwoData
          .vaziatKhesaratHavadesBGCoreId as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.bimehNameh.tarikhShoroo = gregorianDateTime(
          state.StepTwoData.tarikhShoroo
        );
      }
    },
    setStepThreeModel: (state, action) => {
      state.StepThreeData = action.payload;
    },
    setStepThreeCommand: (state, action) => {
      if (state.StepThreeData) {
        state.getCodeShenasehPardakhtShakhsSalesCommand.bimehNameh.taahodMaali = state.StepThreeData.taahodMali
          ?.value as number;
        state.getCodeShenasehPardakhtShakhsSalesCommand.bimehNameh.moddatBimehNamehId = state.StepThreeData
          .modatBimehNameh?.value as number;
        //state.getCodeShenasehPardakhtShakhsSalesCommand.tarhSodoorCoreIdList = state.StepThreeData.tarhSodoorCoreIdList?.map((c: any) => c.value) as string[] ?? [];
      }
      state.getCodeShenasehPardakhtShakhsSalesCommand.discountCode =
        action.payload?.isSuccess === true && action.payload?.data ? action.payload?.data?.discountCode : undefined;
    },

    setStepFourModel: (state, action) => {
      state.StepFourData = action.payload;
    },
    setStepFourCommand: (state, action) => {
      state.getCodeShenasehPardakhtShakhsSalesCommand.tarafHayeGharardad = action.payload;
    },
    setStepFiveModel: (state, action) => {
      state.StepFiveData = action.payload;
    },
    setStepFiveCommand: (state) => {
      if (state.StepFiveData) {
        state.getCodeShenasehPardakhtShakhsSalesCommand.address.codePosti = state.StepFiveData.codePosti;
        state.getCodeShenasehPardakhtShakhsSalesCommand.address.mobile = state.StepFiveData.mobile;
        state.getCodeShenasehPardakhtShakhsSalesCommand.address.tel = state.StepFiveData.telephone;
        state.getCodeShenasehPardakhtShakhsSalesCommand.address.neshani = state.StepFiveData.address as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.address.cityCoreId = state.StepFiveData.cityCoreId
          ?.value as string;
        state.getCodeShenasehPardakhtShakhsSalesCommand.address.email = state.StepFiveData.email as string;
      }
    },
    setHaghBimehPardakhtiCommand: (state, action) => {
      state.haghBimehPardakhti = action.payload;
    },
    setShowConfirmFromUser: (state, action) => {
      state.showConfirmFromUser = action.payload;
    },
    setIsMablaghKharidBimehNamehMoreThanHaghBimeh: (state, action) => {
      state.isMablaghKharidBimehNamehMoreThanHaghBimeh = action.payload;
    },

    sodoorWizardStep: (state, action) => {
      const newStep = action.payload as number;
      if (state.sodoorWizard.begin <= newStep && newStep <= state.sodoorWizard.end) {
        state.sodoorWizard.current = newStep;
      }
    },
    sodoorWizardNextStep: (state) => {
      const nextStep = state.sodoorWizard.current + 1;
      if (nextStep <= state.sodoorWizard.end) {
        state.sodoorWizard.current = nextStep;
      }
    },
    sodoorWizardPreviousStep: (state) => {
      const previousStep = state.sodoorWizard.current - 1;
      if (previousStep >= state.sodoorWizard.begin) {
        state.sodoorWizard.current = previousStep;
      }
      ClearAllToasts();
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getCodeShenasehPardakhtShakhsSalesChangePelak.pending, (state) => {
        state.getCodeShenasehPardakhtShakhsSalesResult.loading = true;
      })
      .addCase(getCodeShenasehPardakhtShakhsSalesChangePelak.fulfilled, (state, action) => {
        state.getCodeShenasehPardakhtShakhsSalesResult.loading = false;
        if (action.payload && action.payload.status === 201) {
          state.getCodeShenasehPardakhtShakhsSalesResult.data = action.payload.data;
          state.isSuccess = true;
        } else {
          state.isSuccess = false;
        }
        return state;
      })
      .addCase(getCodeShenasehPardakhtShakhsSalesChangePelak.rejected, (state) => {
        state.getCodeShenasehPardakhtShakhsSalesResult.loading = false;
      });

    builder
      .addCase(addToOrder.pending, (state) => {
        state.addToOrderResponse.loading = true;
      })
      .addCase(addToOrder.fulfilled, (state) => {
        state.addToOrderResponse.loading = false;
      })
      .addCase(addToOrder.rejected, (state) => {
        state.addToOrderResponse.loading = false;
      });

    builder
      .addCase(estelamSabtAhvalThunk.pending, (state) => {
        state.estelamSabtAhval.loading = true;
      })
      .addCase(estelamSabtAhvalThunk.fulfilled, (state, action) => {
        state.estelamSabtAhval.loading = false;
        state.estelamSabtAhval.data = action.payload;
      })
      .addCase(estelamSabtAhvalThunk.rejected, (state) => {
        state.estelamSabtAhval.loading = false;
      });
    builder
      .addCase(getAddressWithPostCodeThunk.pending, (state) => {
        state.getAddressWithPostCode.loading = true;
      })
      .addCase(getAddressWithPostCodeThunk.fulfilled, (state, action) => {
        state.getAddressWithPostCode.loading = false;
        state.getAddressWithPostCode.data = action.payload;
      })
      .addCase(getAddressWithPostCodeThunk.rejected, (state) => {
        state.getAddressWithPostCode.loading = false;
      });

    builder
      .addCase(getEstelamWithShomarehBimehNamehAndShomarehEntezami.pending, (state) => {
        state.estelamBimehMarkazi.loading = true;
      })
      .addCase(getEstelamWithShomarehBimehNamehAndShomarehEntezami.fulfilled, (state, action) => {
        state.estelamBimehMarkazi.loading = false;
        if (action.payload !== undefined) {
          const tarhHayeSodoor: LabelValueType[] = action.payload?.tarhHayeSodoor?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.estelamBimehMarkazi.data = {
            ...action.payload,
            tarhHayeSodoor: tarhHayeSodoor,
          };

          state.needToEdit =
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.brandCoreId === undefined ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.brandCoreId === null ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.noePelakCoreId === undefined ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.noePelakCoreId === null ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.tipCoreId === undefined ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.tipCoreId === null ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.moredEstefadehCoreId === undefined ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.moredEstefadehCoreId === null ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.saalSakht === undefined ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.saalSakht === null ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.vin === undefined ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.vin === null ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.vin === '' ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.noeVasilehNaghliehCoreId === undefined ||
            state.estelamBimehMarkazi.data?.vasilehNaghlieh.noeVasilehNaghliehCoreId === null;
        }
      })
      .addCase(getEstelamWithShomarehBimehNamehAndShomarehEntezami.rejected, (state) => {
        state.estelamBimehMarkazi.loading = false;
      });
    builder
      .addCase(getActiveTaahodSalesSarneshin.pending, (state) => {
        state.taahodatSalesSarneshin.loading = true;
      })
      .addCase(getActiveTaahodSalesSarneshin.fulfilled, (state, action) => {
        state.taahodatSalesSarneshin.loading = false;
        if (action.payload !== undefined) {
          const item: LabelValueType = {
            value: action.payload.mablaghTaahod,
            label: `${action.payload.mablaghTaahod?.toLocaleString()} ${action.payload.vahedPooli}`,
          };
          state.taahodatSalesSarneshin.data = item;
        }
        return state;
      })
      .addCase(getActiveTaahodSalesSarneshin.rejected, (state) => {
        state.taahodatSalesSarneshin.loading = false;
      });
    builder
      .addCase(getActiveTaahodSalesJaani.pending, (state) => {
        state.taahodatSalesJaani.loading = true;
      })
      .addCase(getActiveTaahodSalesJaani.fulfilled, (state, action) => {
        state.taahodatSalesJaani.loading = false;
        if (action.payload !== undefined) {
          const item: LabelValueType = {
            value: action.payload.mablaghTaahod,
            label: `${action.payload.mablaghTaahod?.toLocaleString()} ${action.payload.vahedPooli}`,
          };
          state.taahodatSalesJaani.data = item;
        }
        return state;
      })
      .addCase(getActiveTaahodSalesJaani.rejected, (state) => {
        state.taahodatSalesJaani.loading = false;
      });
    builder
      .addCase(getAllTaahodatSalesMali.pending, (state) => {
        state.taahodatSalesMali.loading = true;
      })
      .addCase(getAllTaahodatSalesMali.fulfilled, (state, action) => {
        state.taahodatSalesMali.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.mablaghTaahod,
            label: `${item.mablaghTaahod?.toLocaleString()} ${item.vahedPooli}`,
          }));
          state.taahodatSalesMali.data = list;
        }
        return state;
      })
      .addCase(getAllTaahodatSalesMali.rejected, (state) => {
        state.taahodatSalesMali.loading = false;
      });

    builder
      .addCase(estelamShakhsSales.pending, (state) => {
        state.estelamResult.loading = true;
      })
      .addCase(estelamShakhsSales.fulfilled, (state, action) => {
        state.estelamResult.loading = false;
        if (action.payload && action.payload.status === 201) {
          state.estelamResult.data = action.payload.data;
          state.isSuccess = true;
          state.estelamResult.loaded = true;
        } else {
          state.estelamResult = SodoorBimehNamehByTavizPelakInitialState.estelamResult;
          state.isSuccess = false;
        }
        return state;
      })
      .addCase(estelamShakhsSales.rejected, (state) => {
        state.estelamResult.loading = false;
      });

    builder
      .addCase(getAllTarhHayeSodoorByNoeBimeh.pending, (state) => {
        state.tarhTakhfif.loading = true;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.fulfilled, (state, action) => {
        state.tarhTakhfif.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.tarhTakhfif.data = list;
        }
        return state;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.rejected, (state) => {
        state.tarhTakhfif.loading = false;
      });

    builder
      .addCase(getActiveModdatHayeBimehNameh.pending, (state) => {
        state.moddatHayeBimehNameh.loading = true;
      })
      .addCase(getActiveModdatHayeBimehNameh.fulfilled, (state, action) => {
        state.moddatHayeBimehNameh.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.id,
            label: item.title,
          }));
          state.moddatHayeBimehNameh.data = list;
        }
        return state;
      })
      .addCase(getActiveModdatHayeBimehNameh.rejected, (state) => {
        state.moddatHayeBimehNameh.loading = false;
      });

    builder
      .addCase(getAllTipHaByBrand.pending, (state) => {
        state.tipHa.loading = true;
      })
      .addCase(getAllTipHaByBrand.fulfilled, (state, action) => {
        state.tipHa.loading = false;
        const list: LabelValueType[] = action.payload?.map((item: any) => ({
          value: item.coreId,
          label: item.name,
        }));
        state.tipHa.data = list;
      })
      .addCase(getAllTipHaByBrand.rejected, (state) => {
        state.tipHa.loading = false;
      });

    builder
      .addCase(getAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh.pending, (state) => {
        state.moredEstefadehHayeKhodro.loading = true;
      })
      .addCase(getAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh.fulfilled, (state, action) => {
        state.moredEstefadehHayeKhodro.loading = false;
        const list: LabelValueType[] = action.payload?.map((item: any) => ({
          value: item.coreId,
          label: item.displayTitle,
        }));
        state.moredEstefadehHayeKhodro.data = list;
      })
      .addCase(getAllMoredEstefadehHayeKhodroByNoeVasilehNaghlieh.rejected, (state) => {
        state.moredEstefadehHayeKhodro.loading = false;
      });

    builder
      .addCase(getAllBrandHaByNoeVasilehNaghlieh.pending, (state) => {
        state.brandHa.loading = true;
      })
      .addCase(getAllBrandHaByNoeVasilehNaghlieh.fulfilled, (state, action) => {
        state.brandHa.loading = false;
        const list: LabelValueType[] = action.payload?.map((item: any) => ({
          value: item.coreId,
          label: item.displayTitle,
        }));
        state.brandHa.data = list;
      })
      .addCase(getAllBrandHaByNoeVasilehNaghlieh.rejected, (state) => {
        state.brandHa.loading = false;
      });

    builder
      .addCase(getAllAnvaePelak.pending, (state) => {
        state.anvaePelak.loading = true;
      })
      .addCase(getAllAnvaePelak.fulfilled, (state, action) => {
        state.anvaePelak.loading = false;
        const list: LabelValueType[] = action.payload?.map((item: any) => ({
          value: item.coreId,
          label: item.displayTitle,
        }));
        state.anvaePelak.data = list;
      })
      .addCase(getAllAnvaePelak.rejected, (state) => {
        state.anvaePelak.loading = false;
      });

    builder
      .addCase(getAllAnvaeVasilehNaghleyeh.pending, (state) => {
        state.anvaeVasilehNaghleyeh.loading = true;
      })
      .addCase(getAllAnvaeVasilehNaghleyeh.fulfilled, (state, action) => {
        state.anvaeVasilehNaghleyeh.loading = false;
        const list: LabelValueType[] = action.payload?.map((item: any) => ({
          value: item.coreId,
          label: item.displayTitle,
        }));
        state.anvaeVasilehNaghleyeh.data = list;
      })
      .addCase(getAllAnvaeVasilehNaghleyeh.rejected, (state) => {
        state.anvaeVasilehNaghleyeh.loading = false;
      });

    builder
      .addCase(getSerialHayePelakByHarfPelak.pending, (state) => {
        state.serialPelaks.loading = true;
      })
      .addCase(getSerialHayePelakByHarfPelak.fulfilled, (state, action) => {
        state.serialPelaks.loading = false;
        const list: LabelValueType[] = action.payload?.map((item: any) => ({
          value: item.coreId,
          label: item.serial,
        }));
        state.serialPelaks.data = list;
      })
      .addCase(getSerialHayePelakByHarfPelak.rejected, (state) => {
        state.serialPelaks.loading = false;
      });

    builder
      .addCase(getAllHarfHayePelak.pending, (state) => {
        state.harfHayePelak.loading = true;
      })
      .addCase(getAllHarfHayePelak.fulfilled, (state, action) => {
        state.harfHayePelak.loading = false;
        const list: LabelValueType[] = action.payload?.map((item: any) => ({
          value: item.id,
          label: item.title,
        }));
        state.harfHayePelak.data = list;
      })
      .addCase(getAllHarfHayePelak.rejected, (state) => {
        state.harfHayePelak.loading = false;
      });

    builder
      .addCase(getAllRangHayeKhodro.pending, (state) => {
        state.rangHa.loading = true;
      })
      .addCase(getAllRangHayeKhodro.fulfilled, (state, action) => {
        state.rangHa.loading = false;
        if (action.payload !== undefined) {
          state.rangHa.data = action.payload;
        }
        return state;
      })
      .addCase(getAllRangHayeKhodro.rejected, (state) => {
        state.rangHa.loading = false;
      });

    builder
      .addCase(getEstelamDarsadTakhfif.pending, (state) => {
        state.estelamDarsadTakhfif.loading = true;
      })
      .addCase(getEstelamDarsadTakhfif.fulfilled, (state, action) => {
        state.estelamDarsadTakhfif.loading = false;
        if (action.payload !== undefined) {
          state.estelamDarsadTakhfif.data = action.payload;
        }
        return state;
      })
      .addCase(getEstelamDarsadTakhfif.rejected, (state) => {
        state.estelamDarsadTakhfif.loading = false;
      });

    builder
      .addCase(GetAllAnvaeSherkatBimeh.pending, (state) => {
        state.anvaeSherkatBimeh.loading = true;
      })
      .addCase(GetAllAnvaeSherkatBimeh.fulfilled, (state) => {
        state.anvaeSherkatBimeh.loading = false;

        return state;
      })
      .addCase(GetAllAnvaeSherkatBimeh.rejected, (state) => {
        state.anvaeSherkatBimeh.loading = false;
      });

    builder
      .addCase(getAllTakhfifHayeJarimehSales.pending, (state) => {
        state.takhfifHayeJarimehSales.loading = true;
      })
      .addCase(getAllTakhfifHayeJarimehSales.fulfilled, (state, action) => {
        state.takhfifHayeJarimehSales.loading = false;
        if (action.payload !== undefined) {
          const list: ITakhfifHayeJarimehSalesQr[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.title,
            tedadJaani: item.tedadJaani,
            tedadMaali: item.tedadMaali,
            tedadSarneshin: item.tedadSarneshin,
          }));
          state.takhfifHayeJarimehSales.data = list;
        }

        return state;
      })
      .addCase(getAllTakhfifHayeJarimehSales.rejected, (state) => {
        state.takhfifHayeJarimehSales.loading = false;
      });

    builder
      .addCase(getAllTakhfifHayeJarimehSarneshin.pending, (state) => {
        state.takhfifHayeJarimehSarneshin.loading = true;
      })
      .addCase(getAllTakhfifHayeJarimehSarneshin.fulfilled, (state, action) => {
        state.takhfifHayeJarimehSarneshin.loading = false;
        if (action.payload !== undefined) {
          const list: ITakhfifHayeJarimehSarneshinQr[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.title,
            tedadJaani: item.tedadJaani,
            tedadMaali: item.tedadMaali,
            tedadSarneshin: item.tedadSarneshin,
          }));
          state.takhfifHayeJarimehSarneshin.data = list;
        }
        return state;
      })
      .addCase(getAllTakhfifHayeJarimehSarneshin.rejected, (state) => {
        state.takhfifHayeJarimehSarneshin.loading = false;
      });

    builder
      .addCase(getBimehNamehExpireDateMaxDay.pending, (state) => {
        state.bimehNamehExpireDateMaxDay.loading = true;
      })
      .addCase(getBimehNamehExpireDateMaxDay.fulfilled, (state) => {
        state.bimehNamehExpireDateMaxDay.loading = false;

        return state;
      })
      .addCase(getBimehNamehExpireDateMaxDay.rejected, (state) => {
        state.bimehNamehExpireDateMaxDay.loading = false;
      });

    builder
      .addCase(isDuplicateBimehNamehShakhsSalesInOrder.pending, (state) => {
        state.isDuplicateBimehNamehInOrder.loading = true;
        state.isDuplicateBimehNamehInOrder.data = null;
      })
      .addCase(isDuplicateBimehNamehShakhsSalesInOrder.fulfilled, (state, action) => {
        state.isDuplicateBimehNamehInOrder.loading = false;
        if (action.payload !== undefined) {
          state.isDuplicateBimehNamehInOrder.data = action.payload;
        }
        return state;
      })
      .addCase(isDuplicateBimehNamehShakhsSalesInOrder.rejected, (state) => {
        state.isDuplicateBimehNamehInOrder.loading = false;
      });
  },
});

export const {
  setSodoorBimehNamehByTavizPelakInitialState,
  setTarafHayeGharardadCommand,
  setTarafHayeGharardadModel,
  setStepOneModel,
  setStepOneCommand,
  setEstelamBimehMarkazi,
  setShowConfirmFromUser,
  setIsMablaghKharidBimehNamehMoreThanHaghBimeh,
  sodoorWizardStep,
  sodoorWizardNextStep,
  setStepFiveCommand,
  setStepFiveModel,
  sodoorWizardPreviousStep,
  setHaghBimehPardakhtiCommand,
  setStepTwoModel,
  setStepTwoCommand,
  setStepThreeCommand,
  setStepThreeModel,
  setStepFourModel,
  setStepFourCommand,
  setEstelamSalesCommand,
} = sodoorBimehNamehByTavizPelakSlice.actions;

export default sodoorBimehNamehByTavizPelakSlice.reducer;
